export interface DashboardConfig {
  sidebar: {
    showFillIntakeForm: boolean;
    showInviteClient: boolean;
    showIntakeFormLink: boolean;
    quickStartDirect: boolean;
    showIntegrations: boolean;
    showEngagementCampaigns: boolean;
    showSubscription: boolean;
    showTeam: boolean;
    showMetrics: boolean;
  };
  clients: {
    headerPrimaryAction: 'invite' | 'quickStart';
    hiddenColumnIds: string[];
    showExploreQuotes: boolean;
  };
}

export const DEFAULT_DASHBOARD_CONFIG: DashboardConfig = {
  sidebar: {
    showFillIntakeForm: true,
    showInviteClient: true,
    showIntakeFormLink: true,
    quickStartDirect: false,
    showIntegrations: true,
    showEngagementCampaigns: true,
    showSubscription: true,
    showTeam: true,
    showMetrics: true,
  },
  clients: {
    headerPrimaryAction: 'invite',
    hiddenColumnIds: [],
    showExploreQuotes: true,
  },
};
